const SupplierServicesType = (type, supplierId) => {
  if (supplierId === 801 || supplierId === 804 || supplierId === 901) {
    return "Economy";
  } else if (supplierId === 4901) {
    return "Saver";
  } else if (type === "E") {
    return "Economy";
  } else if (type === "X") {
    return "Express";
  } else if (type === "C") {
    return "Kargo";
  } else if (type === "P") {
    return "Postal";
  }
};

export default SupplierServicesType;
